module.exports = __webpack_public_path__ + "img/vue-weather.6612374d.png";